module.exports = __webpack_public_path__ + "img/backspace.be3fac6c.svg";